import React, { useEffect } from 'react'
import * as locCon from "../LocalConstants"

import Title from 'antd/es/typography/Title';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { StreamQualityChartHook } from '../components/charts/hooks/StreamQualityChartHook';
import streamData from "../data/data_streams_summary.json"


function DashboardDataStreamQuality() {
  const i18n = RefContextLanguage();




  // Chart
  const [objectReference, chart] = StreamQualityChartHook({})


  useEffect(() => {

    if (!chart.initialized) {
      // Initialize Chart Data
      chart.initialize()
    }

    // Rebuilt on a locale change too: the chart is drawn imperatively, so it
    // does not re-render with the rest of the page.
    chart.build(streamData[locCon.SUMMARY_COVERAGE_INTERVALS])

  }, [chart, i18n])



  return (
    <div className="mainContainer">
      <Title level={1}>{i18n.t('dataStreamQuality')}</Title>
      <div style={{ minWidth: "98vw", minHeight: "250vh" }}>
        <svg ref={objectReference} />
      </div>

    </div>


  )
}

export default DashboardDataStreamQuality